import React, { FunctionComponent, useEffect, useState } from 'react';


export const FAQ: FunctionComponent<{}> = ({ }) => { 
        return <div className='px-5 pb-3'>
            <h1>FAQ</h1>
        </div>
}